const fonts = {
  heading: "Poppins",
  body: "Poppins"
};

export default fonts;
